(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let scrollContainer = document.querySelector(".gallery");
  let backBtn = document.getElementById("backBtn");
  let nextBtn = document.getElementById("nextBtn");

  scrollContainer.addEventListener("wheel", (evt) => {
    evt.preventDefault();
    scrollContainer.scrollLeft += evt.deltaY;
    scrollContainer.style.scrollBehavior = "smooth";
  });

  nextBtn.addEventListener("click", () => {
    scrollContainer.style.scrollBehavior = "smooth";
    scrollContainer.scrollLeft += 300;
  });

  backBtn.addEventListener("click", () => {
    scrollContainer.style.scrollBehavior = "smooth";
    scrollContainer.scrollLeft -= 300;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-slider-with-links"] && !Shopify.designMode) return;
  try {
    
const linksCarousel = document.querySelector(".slider-with-links-carousel"),
    linksItems = linksCarousel.querySelectorAll(".slider-with-links-item"),
    linksFirstImg = linksItems.length > 0 ? linksItems[0].querySelector("img") : null;

let isDragging = false,
    isMoved = false,
    startX = 0,
    scrollLeft = 0;

// Function to update image width dynamically
const calculateImgWidth = () => {
    if (linksFirstImg) {
        const imgStyles = getComputedStyle(linksFirstImg);
        const imgWidth = linksFirstImg.offsetWidth;
        const marginRight = parseInt(imgStyles.marginRight, 10);
        return imgWidth + marginRight; // Image width + margin
    }
    return 0;
};

// Initial calculation of image width
let linksFirstImgWidth = calculateImgWidth();
let autoScrollInterval;

// Auto-scroll function
const autoScroll = () => {
    linksCarousel.scrollLeft += linksFirstImgWidth;
    if (linksCarousel.scrollLeft >= linksCarousel.scrollWidth - linksCarousel.offsetWidth) {
        linksCarousel.scrollLeft = 0; // Loop back to start
    }
};

// Start auto-scroll
const startAutoScroll = () => {
    autoScrollInterval = setInterval(autoScroll, 3000); // Change slides every 3 seconds
};

// Stop auto-scroll when user interacts
const stopAutoScroll = () => {
    clearInterval(autoScrollInterval);
};

// Drag Start
const dragStart = (e) => {
    isDragging = true;
    isMoved = false;
    linksCarousel.classList.add("dragging");
    startX = e.pageX || e.touches[0].pageX;
    scrollLeft = linksCarousel.scrollLeft;
    stopAutoScroll();
};

// Dragging
const dragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    isMoved = true; // Mark as moved
    const x = e.pageX || e.touches[0].pageX;
    const move = (x - startX) * 1.2;
    linksCarousel.scrollLeft = scrollLeft - move;
};

// Drag Stop
const dragStop = (e) => {
    isDragging = false;
    linksCarousel.classList.remove("dragging");
    startAutoScroll(); // Restart auto-scroll
};

// Prevent click when dragging
linksItems.forEach((item) => {
    item.addEventListener("click", (e) => {
        if (isMoved) {
            e.preventDefault(); // Prevent click if user dragged
        }
    });
});

// Attach drag event listeners
linksCarousel.addEventListener("mousedown", dragStart);
linksCarousel.addEventListener("mousemove", dragging);
linksCarousel.addEventListener("mouseup", dragStop);
linksCarousel.addEventListener("mouseleave", dragStop);
linksCarousel.addEventListener("touchstart", dragStart);
linksCarousel.addEventListener("touchmove", dragging);
linksCarousel.addEventListener("touchend", dragStop);

// Resize event for recalculating image width
window.addEventListener("resize", () => {
    linksFirstImgWidth = calculateImgWidth();
});

// Start auto-scroll on page load
if (linksFirstImgWidth > 0) startAutoScroll();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-slider"] && !Shopify.designMode) return;
  try {
    
const carousel = document.querySelector(".carousel"),
    firstImg = carousel.querySelectorAll("img")[0];
const arrowIcons = document.querySelectorAll(".carousel-wrap .arrow");

let isDragStart = false,
    isDragging = false,
    prevPageX,
    prevScrollLeft;

// Recalculate image width dynamically
const calculateImgWidth = () => {
    if (firstImg) {
        const imgStyles = getComputedStyle(firstImg);
        const imgWidth = firstImg.offsetWidth;
        const marginRight = parseInt(imgStyles.marginRight);
        return imgWidth + marginRight; // Image width + margin
    }
    return 0;
};

// Initial calculation of image width
let firstImgWidth = calculateImgWidth();
let autoScrollInterval;

// Function to scroll the carousel
const autoScroll = () => {
    carousel.scrollLeft += firstImgWidth;
    // If the carousel reaches the end, reset to the start
    if (carousel.scrollLeft >= carousel.scrollWidth - carousel.offsetWidth) {
        carousel.scrollLeft = 0;
    }
};

// Set up the auto-scroll
const startAutoScroll = () => {
    autoScrollInterval = setInterval(autoScroll, 3000); // Change slides every 3 seconds
};

// Stop auto-scroll when dragging or interacting manually
const stopAutoScroll = () => {
    clearInterval(autoScrollInterval);
};

// Add event listeners for the arrow icons
arrowIcons.forEach((icon) => {
    icon.addEventListener("click", () => {
        stopAutoScroll(); // Stop auto-scroll temporarily on manual navigation
        firstImgWidth = calculateImgWidth(); // Recalculate image width
        const direction = icon.id === "backBtn" ? -firstImgWidth : firstImgWidth;
        carousel.scrollLeft += direction; // Scroll by one image width
        startAutoScroll(); // Restart auto-scroll after manual interaction
    });
});

// Handle drag start
const dragStart = (e) => {
    isDragStart = true;
    isDragging = false;
    prevPageX = e.pageX;
    prevScrollLeft = carousel.scrollLeft;
    stopAutoScroll(); // Stop auto-scroll while dragging
};

// Handle dragging
const dragging = (e) => {
    if (!isDragStart) return;
    e.preventDefault();
    isDragging = true;
    carousel.classList.add("dragging");
    let positionDiff = e.pageX - prevPageX;
    carousel.scrollLeft = prevScrollLeft - positionDiff;
};

// Handle drag stop
const dragStop = () => {
    if (!isDragStart) return;
    isDragStart = false;
    carousel.classList.remove("dragging");

    if (!isDragging) return;

    firstImgWidth = calculateImgWidth(); // Recalculate image width
    // Snap to the closest slide
    const scrollLeft = carousel.scrollLeft;
    const closestSlide = Math.round(scrollLeft / firstImgWidth) * firstImgWidth;

    // Smoothly scroll to the closest slide
    carousel.scrollTo({
        left: closestSlide,
        behavior: "smooth",
    });

    startAutoScroll(); // Restart auto-scroll after dragging
};

// Add drag event listeners
carousel.addEventListener("mousedown", dragStart);
carousel.addEventListener("mousemove", dragging);
carousel.addEventListener("mouseup", dragStop);
carousel.addEventListener("mouseleave", dragStop);

// Recalculate image width on window resize for responsiveness
window.addEventListener("resize", () => {
    firstImgWidth = calculateImgWidth();
});

// Start auto-scroll when the page loads
if (firstImgWidth > 0) startAutoScroll();

  } catch(e) { console.error(e); }
})();
})();
